import React, { Component } from 'react';

class IndustriesSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      industriesData: [
        {
          id: 1,
          icon: '../images/uniform.svg',
          title: 'ON SITE UNIFORMED SECURITY',
          description: 'Trained security personnel stationed on-site to provide visible protection and rapid response.'
        },
        {
          id: 2,
          icon: '../images/dd.png', 
          title: 'CONCIERGE',
          description: 'Friendly front-desk professionals offering guest assistance, access control, and property support.'
        },
        {
          id: 3,
          icon: '../images/sec.png',
          title: 'CONSTRUCTION SECURITY',
          description: 'Security solutions tailored to protect construction sites from theft, vandalism, and unauthorized access.'
        },
        {
          id: 4,
          icon: '../images/rem.png',
          title: 'MOBILE PATROL',
          description: 'Marked security vehicles conducting scheduled or random patrols to deter and detect suspicious activity.'
        },
        {
          id: 5,
          icon: '../images/es.png',
          title: 'EVENT SECURITY',
          description: 'Specialized security teams ensuring crowd control and safety for events of all sizes.'
        },
        {
          id: 6,
          icon: '../images/fw.png',
          title: 'FIRE WATCH',
          description: 'Qualified guards monitoring properties for fire risks during system outages or high-risk conditions.'
        },
        {
          id: 7,
          icon: '../images/lp.png',
          title: 'LOSS PREVENTION',
          description: 'Security strategies aimed at reducing theft, fraud, and inventory shrinkage in retail or commercial settings.'
        },
        {
          id: 8,
          icon: '../images/ac.png',
          title: 'ACCESS CONTROL',
          description: 'Systems and personnel that manage and restrict entry to authorized individuals only.'
        }
      ]
    };
  }

  renderServiceCard = (service) => {
    return (
      <div key={service.id} className="col-xl-3 col-lg-6 col-md-6 mb-4">
        <div className="service-card">
          <div className="service-icon p-3 mb-3" style={{width: 'fit-content'}}>
            <img alt={service.title.toLowerCase()} src={service.icon} />
          </div>
          <h5 className="fw-bold mb-3">{service.title}</h5>
          <p className="text-muted">
            {service.description}
          </p>
          <div className="triangle-bottomright-dark"></div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="services-section bg-dark text-white py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="d-flex justify-content-center align-items-center mb-3">
                <div className="bg-white rounded-circle p-2 me-3">
                  <i className="fas fa-shield-alt text-dark"></i>
                </div>
                <span className="text-uppercase text-white small-upper-text">WHO WE WORK WITH</span>
              </div>
              <h2 className="display-5 fw-bold mb-4">INDUSTRIES</h2>
              <p className="lead text-muted mx-auto" style={{maxWidth: '800px'}}>
                We tailor our security services to a variety of industries, offering scalable solutions for businesses of all sizes and complexities
              </p>
            </div>
          </div>
          <div className="row mb-4">
            {this.state.industriesData.map(this.renderServiceCard)}
          </div>
        </div>
      </div>
    );
  }
}

export default IndustriesSection;